import Service from "./Service";
const resource = "/page";

export default {
	async getPageBySlug($lang, $slug = false, $postType = "post") {
		const params = {
			slug: $slug,
			postType: $postType,
		};

		if ($lang) {
			params["lang"] = $lang;
		}

		const resp = await Service.get(`${resource}`, {
			params: params,
		});

		return resp.data;
	},
};
